import * as S from './styles';
import { FmdBadOutlined } from '@mui/icons-material';

export default function NoClassSectionData() {
  return (
    <S.EmptyStateContainer>
      <FmdBadOutlined
        sx={{
          width: 60,
          height: 70,
          color: '#C2C1C1',
        }}
      />

      <S.MessageText>
        There are no class sections created for this school yet.
      </S.MessageText>
      <S.MessageText>
        Click the "Create class section" button below to add a new class
        section.
      </S.MessageText>
    </S.EmptyStateContainer>
  );
}
